export const TEXT = {
    DatabaseBrowser: {en: "Database Browser", ar: "متصفح قواعد البيانات"},
    DBGroups: {en: "DBGroup Templates", ar: "قوالب مجموعات البيانات"},
    Databases: {en: "Databases", ar: "قواعد البيانات"},
    Fields: {en: "fields", ar: "حقول"},
    Records: {en: "records", ar: "سجلات"},
    Local: {en: "Local", ar: "محلي"},
    Global: {en: "Global", ar: "عام"},
    Created: {en: "Created", ar: "تم الإنشاء"},
    FieldsList: {en: "Fields List", ar: "قائمة الحقول"},
    ViewDetails: {en: "View Details", ar: "عرض التفاصيل"},
    BasedOn: {en: "Based on", ar: "مبني على"},
    RecentRecords: {en: "Recent Records", ar: "السجلات الأخيرة"},
    Type: {en: "Type", ar: "النوع"},
    DBGroupTemplate: {en: "DBGroup Template", ar: "قالب مجموعة البيانات"},
    Database: {en: "Database", ar: "قاعدة بيانات"},
    Version: {en: "Version", ar: "الإصدار"},
    Storage: {en: "Storage", ar: "التخزين"},
    Close: {en: "Close", ar: "إغلاق"},
    NoDBGroupsFound: {en: "No DBGroup templates found. Create one to get started.", ar: "لم يتم العثور على قوالب مجموعات البيانات. أنشئ واحدًا للبدء."},
    NoDatabasesFound: {en: "No databases found. Create one to get started.", ar: "لم يتم العثور على قواعد بيانات. أنشئ واحدة للبدء."},
    PushToServer: {en: "Push to Server", ar: "رفع للخادم"},
    Pushing: {en: "Pushing...", ar: "جاري الرفع..."},
    PleaseLogin: {en: "Please login to push to server", ar: "يرجى تسجيل الدخول للرفع إلى الخادم"},
    ConfirmPushDbGroup: {en: "Push this DBGroup template to the server?", ar: "رفع قالب مجموعة البيانات هذا إلى الخادم؟"},
    ConfirmPushDatabase: {en: "Push this Database to the server?", ar: "رفع قاعدة البيانات هذه إلى الخادم؟"},
    Error: {en: "Error", ar: "خطأ"},
    NetworkError: {en: "Network error. Please try again.", ar: "خطأ في الشبكة. يرجى المحاولة مرة أخرى."},
    Outdated: {en: "Outdated", ar: "قديم"},
    Synced: {en: "Synced", ar: "متزامن"},
    ServerOnly: {en: "Server Only", ar: "على الخادم فقط"},
    Download: {en: "Download", ar: "تنزيل"},
    Downloading: {en: "Downloading...", ar: "جاري التنزيل..."},
    ConfirmDownload: {en: "Download from server?", ar: "تنزيل من الخادم؟"},
    Downloaded: {en: "Downloaded successfully", ar: "تم التنزيل بنجاح"},
    AccessControl: {en: "Access Control", ar: "التحكم في الوصول"},
    Owners: {en: "Owners", ar: "المالكون"},
    Admins: {en: "Admins", ar: "المسؤولون"},
    Contributors: {en: "Contributors", ar: "المساهمون"},
    Readers: {en: "Readers", ar: "القراء"},
    None: {en: "None", ar: "لا يوجد"},
    ManageRecords: {en: "View Records", ar: "عرض السجلات"},
    AddRecord: {en: "Add Record", ar: "إضافة سجل"},
    EditRecord: {en: "Edit Record", ar: "تعديل السجل"},
    DeleteRecord: {en: "Delete", ar: "حذف"},
    SaveRecord: {en: "Save", ar: "حفظ"},
    Cancel: {en: "Cancel", ar: "إلغاء"},
    ConfirmDelete: {en: "Are you sure you want to delete this record?", ar: "هل أنت متأكد من حذف هذا السجل؟"},
    RecordDeleted: {en: "Record deleted successfully", ar: "تم حذف السجل بنجاح"},
    RecordSaved: {en: "Record saved successfully", ar: "تم حفظ السجل بنجاح"},
    NoRecords: {en: "No records yet. Add one to get started.", ar: "لا توجد سجلات بعد. أضف واحدة للبدء."},
    NoPermission: {en: "You don't have permission to perform this action", ar: "ليس لديك إذن لتنفيذ هذا الإجراء"},
    FillAllFields: {en: "Please fill all mandatory fields", ar: "يرجى ملء جميع الحقول المطلوبة"},
    Actions: {en: "Actions", ar: "إجراءات"},
    QuickView: {en: "Quick View", ar: "عرض سريع"},
    OpenInPage: {en: "Open in Page", ar: "فتح في صفحة"},
    ManageAccess: {en: "Manage Access", ar: "إدارة الوصول"},
    ManagePermissions: {en: "Manage Permissions", ar: "إدارة الصلاحيات"},
    SearchUsers: {en: "Search Users", ar: "البحث عن المستخدمين"},
    SelectUser: {en: "Select a user", ar: "اختر مستخدمًا"},
    SelectPermissionType: {en: "Select permission type", ar: "اختر نوع الصلاحية"},
    AddUser: {en: "Add User", ar: "إضافة مستخدم"},
    RemoveUser: {en: "Remove", ar: "إزالة"},
    PermissionUpdated: {en: "Permission updated successfully", ar: "تم تحديث الصلاحية بنجاح"},
    ConfirmRemove: {en: "Remove this user's access?", ar: "إزالة وصول هذا المستخدم؟"},
    Supervised: {en: "Supervised", ar: "تحت الإشراف"},
    CurrentPermissions: {en: "Current Permissions", ar: "الصلاحيات الحالية"},
    AddNewUser: {en: "Add New User", ar: "إضافة مستخدم جديد"},
    AddPermission: {en: "Add Permission", ar: "إضافة صلاحية"},
    SearchUser: {en: "Search User", ar: "البحث عن مستخدم"},
    PermissionType: {en: "Permission Type", ar: "نوع الصلاحية"},
    Adding: {en: "Adding...", ar: "جاري الإضافة..."},
    NoPermissionsYet: {en: "No permissions configured yet", ar: "لم يتم تكوين أي صلاحيات بعد"},
    SelectUserAndPermission: {en: "Please select a user and permission type", ar: "يرجى اختيار مستخدم ونوع صلاحية"},
    ConfirmRemovePermission: {en: "Remove this permission?", ar: "إزالة هذه الصلاحية؟"},
}
export default TEXT;